// extracted by mini-css-extract-plugin
module.exports = {"row":"EnrollClinic_row__D4H_W"};